import { useCallback } from 'react';
import { FormikValues } from 'formik';
import { useAlert, useNavigate, handleMutation } from '@gv/triage-components';

import { useHospitalParams } from 'hooks';
import { useCreatePetMutation } from 'store/api/clients';

import { PetForm } from './form';
import { PetFormPage } from './types';
import { initialValues, getCreatePayload } from './config';

const PetNewGlobal = ({ clientId }: PetFormPage): JSX.Element => {
  const navigate = useNavigate();
  const [create, mutation] = useCreatePetMutation();
  const { showErrorAlert } = useAlert();
  const onSuccess = useCallback(() => navigate(-1), []);
  handleMutation({ ...mutation, onSuccess });

  const onSubmit = async (values: FormikValues) => {
    const dataRes: any = await create(
      getCreatePayload({
        values,
        clientId,
      })
    );
    if (
      dataRes?.data?.dataValues?.message_alert &&
      dataRes?.data?.dataValues?.message_alert !== ''
    ) {
      showErrorAlert(dataRes?.data?.dataValues?.message_alert);
    }
  };

  return <PetForm onSubmit={onSubmit} initialValues={initialValues} />;
};

const PetNew = (): JSX.Element => {
  const { clientId } = useHospitalParams();
  return <PetNewGlobal clientId={clientId!} />;
};

export { PetNew, PetNewGlobal };
